export enum TireDiscardReason {
    CUT = 'CUT',                        // Corte lateral
    DISPLACEMENT = 'DISPLACEMENT',      // Pneu deslocado
    BLOWOUT = 'BLOWOUT',                // Pneu estourou
    WEAR = 'WEAR',                      // Desgaste natural
    FLAT = 'FLAT',                      // Rodagem vazio (baixa pressão)
    BEAD = 'BEAD',                      // Dano no talão
    IRREGULAR = 'IRREGULAR',            // Desgaste irregular
    HEAT = 'HEAT',                      // Talão deteriorado por aquecimento
    HOLE = 'HOLE',                      // Corte ou furo sem possibilidade de reparo
    LOCAL_WEAR = 'LOCAL_WEAR',          // Desgaste localizado
    CHIPPING = 'CHIPPING',              // Múltiplos picotamentos na banda
    BULGE = 'BULGE',                    // Bolsa de ar externa
    CROWN = 'CROWN',                    // Dano na coroa
    IMPACT = 'IMPACT',                  // Quebra por impacto
    REPAIR = 'REPAIR',                  // Falha no reparo
    CRACK = 'CRACK'                     // Rachadura próxima do talão
}
